import React, { useState, useEffect, useRef, FC } from 'react'
import t from '../../../translations/main'

import Flex from 'src/components/Layout/Flex/Flex'
import Font from 'src/components/Core/Typography/Font/Font'
import Table from 'src/components/Organisms/Table/Table'
import Pagination from 'src/components/Atoms/Pagination/Pagination'
import Spinner from 'src/components/Core/Loading/Spinner/Spinner'

import {
  SearchResultWrapper,
  TableSpinnerWrapper,
} from './TablePaginator.styles'

import {
  TablePaginatorProps
} from './types'

const TablePaginator: FC<TablePaginatorProps> = props => {
  const { currentPage, totalItems, tableData, updateCurrentPage, limitPerPage, sortTypes, showRecordsCount } = props
  const [isLoading, setLoading] = useState<boolean>(true)
  const [height, setHeight] = useState<null | number>(null)
  const ref = useRef(null)

  const LIMIT_PER_PAGE = limitPerPage || 10

  useEffect(() => {
    if (tableData?.length === 1) setHeight(clientHeight => clientHeight || ref?.current?.clientHeight || null)
  }, [isLoading])

  useEffect(() => {
    setLoading(!tableData?.[currentPage - 1] || tableData?.[currentPage - 1]?.length === 0)
  }, [tableData, currentPage])

  const showPagination: boolean = totalItems === null ? false : totalItems > LIMIT_PER_PAGE
  const FIRST_CURRENT_PAGE: number = Math.ceil(currentPage * LIMIT_PER_PAGE - LIMIT_PER_PAGE + 1)

  if(!props.show) return null

  return (
    <SearchResultWrapper removePadding={props?.removePadding}>
      {tableData?.[0]?.length === 0 ? (
        <Font>{t('global.empty')}</Font>
      ) : (
        <>
          {isLoading || !tableData?.[currentPage - 1] ? (
            <TableSpinnerWrapper minHeight={height}>
              <Spinner removeFullscreen />
            </TableSpinnerWrapper>
          ) : (
            <TableSpinnerWrapper ref={ref} minHeight={height} alignItems='flex-start'>
              <Table
                lastGrey={props.lastGrey}
                version={props.version}
                tableData={tableData?.[currentPage - 1]}
                tableColumns={props.tableColumns}
                formatRowProps={props.formatRowProps}
                formatCellProps={props.formatCellProps}
                selectedRowIndex={props.selectedRowIndex}
                addScrollToTableBody={props.addScrollToTableBody}
                sortTypes={sortTypes}
              />
            </TableSpinnerWrapper>
          )}
          {showPagination && (
            <Flex maxWidth justifyContent={showRecordsCount ? 'space-between' : 'flex-end'}>
              {
                showRecordsCount &&
              <Font tag='h6'>{t('components.tablePaginator.records', {
                FIRST_CURRENT_PAGE,
                LAST_CURRENT_PAGE: Math.ceil((FIRST_CURRENT_PAGE + LIMIT_PER_PAGE - 1) > totalItems ? totalItems : FIRST_CURRENT_PAGE + LIMIT_PER_PAGE - 1),
                AMOUNT: totalItems
              })}</Font>
              }
              <Pagination
                currentPage={currentPage}
                totalPages={Math.ceil(totalItems / LIMIT_PER_PAGE)}
                onPageChange={page => updateCurrentPage && updateCurrentPage(page)}
              />
            </Flex>
          )}
        </>
      )}
    </SearchResultWrapper>
  )
}

export default TablePaginator
